<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 100 100"
  preserveAspectRatio="xMidYMid"
>
  <g transform="translate(86,50)" style="animation-play-state: running; animation-delay: 0s">
    <g transform="rotate(0)" style="animation-play-state: running; animation-delay: 0s">
      <circle
        cx="0"
        cy="0"
        r="5"
        fill="currentcolor"
        fill-opacity="1"
        style="animation-play-state: running; animation-delay: 0s"
      >
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.64s"
          values="2 2;1 1"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          style="animation-play-state: running; animation-delay: 0s"
        ></animateTransform>
        <animate
          attributeName="fill-opacity"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          values="1;0"
          begin="-0.64s"
          style="animation-play-state: running; animation-delay: 0s"
        ></animate>
      </circle>
    </g>
  </g>
  <g
    transform="translate(61.124611797498105,84.23803458662553)"
    style="animation-play-state: running; animation-delay: 0s"
  >
    <g transform="rotate(72)" style="animation-play-state: running; animation-delay: 0s">
      <circle
        cx="0"
        cy="0"
        r="5"
        fill="currentcolor"
        fill-opacity="0.8"
        style="animation-play-state: running; animation-delay: 0s"
      >
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.48s"
          values="2 2;1 1"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          style="animation-play-state: running; animation-delay: 0s"
        ></animateTransform>
        <animate
          attributeName="fill-opacity"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          values="1;0"
          begin="-0.48s"
          style="animation-play-state: running; animation-delay: 0s"
        ></animate>
      </circle>
    </g>
  </g>
  <g
    transform="translate(20.875388202501895,71.16026908252904)"
    style="animation-play-state: running; animation-delay: 0s"
  >
    <g transform="rotate(144)" style="animation-play-state: running; animation-delay: 0s">
      <circle
        cx="0"
        cy="0"
        r="5"
        fill="currentcolor"
        fill-opacity="0.6"
        style="animation-play-state: running; animation-delay: 0s"
      >
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.32s"
          values="2 2;1 1"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          style="animation-play-state: running; animation-delay: 0s"
        ></animateTransform>
        <animate
          attributeName="fill-opacity"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          values="1;0"
          begin="-0.32s"
          style="animation-play-state: running; animation-delay: 0s"
        ></animate>
      </circle>
    </g>
  </g>
  <g
    transform="translate(20.87538820250189,28.83973091747097)"
    style="animation-play-state: running; animation-delay: 0s"
  >
    <g transform="rotate(216)" style="animation-play-state: running; animation-delay: 0s">
      <circle
        cx="0"
        cy="0"
        r="5"
        fill="currentcolor"
        fill-opacity="0.4"
        style="animation-play-state: running; animation-delay: 0s"
      >
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.16s"
          values="2 2;1 1"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          style="animation-play-state: running; animation-delay: 0s"
        ></animateTransform>
        <animate
          attributeName="fill-opacity"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          values="1;0"
          begin="-0.16s"
          style="animation-play-state: running; animation-delay: 0s"
        ></animate>
      </circle>
    </g>
  </g>
  <g
    transform="translate(61.124611797498105,15.761965413374469)"
    style="animation-play-state: running; animation-delay: 0s"
  >
    <g transform="rotate(288)" style="animation-play-state: running; animation-delay: 0s">
      <circle
        cx="0"
        cy="0"
        r="5"
        fill="currentcolor"
        fill-opacity="0.2"
        style="animation-play-state: running; animation-delay: 0s"
      >
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="0s"
          values="2 2;1 1"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          style="animation-play-state: running; animation-delay: 0s"
        ></animateTransform>
        <animate
          attributeName="fill-opacity"
          keyTimes="0;1"
          dur="0.8s"
          repeatCount="indefinite"
          values="1;0"
          begin="0s"
          style="animation-play-state: running; animation-delay: 0s"
        ></animate>
      </circle>
    </g>
  </g>
</svg>
